<template>
  <div>
    <MyNav :no-bg="!headerBg" :showBorder="showBorder" :fullWidth="fullWidth" />
    <nuxt />
  </div>
</template>

<script>
import MyNav from "../components/MyNav.vue";
import "./index.less";
import { jsApiSignature } from "../api/index";

export default {
  components: {
    MyNav,
  },
  computed: {
    headerBg() {
      return !(this.$route.name === "lang-html-news-detail-id");
    },
    showBorder() {
      return this.$route.name !== "lang";
    },
    fullWidth() {
      return this.$store.state.isMobileSite || this.$route.name === "lang";
    },
  },
  watch: {
    $route() {
      this.wxJS();
      if (this.$route.hash) {
        setTimeout(() => {
          this.scrollTo(this.$route.hash);
        }, 1);
      }
    },
  },
  methods: {
    wxJS() {
      if (!/MicroMessenger/.test(window.navigator.userAgent)) {
        return;
      }
      if (!window.wx) {
        return;
      }
      jsApiSignature()
        .then((res) => {
          if (!res || !res.miniAppCode) {
            return;
          }
          res.nonceStr = res.noncestr;
          res.jsApiList = ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage", "onMenuShareTimeline"]; // 'chooseImage', 'previewImage'
          window.wx && window.wx.config(res);
          wx.ready(function () {
            //需在用户可能点击分享按钮前就先调用
            const config = {
              title: window.document.title, // 分享标题
              desc: document.getElementsByTagName("meta")["description"].content, // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: `${window.location.protocol}//${window.location.host}/icon.png`, // 分享图标
            };
            wx.updateAppMessageShareData({
              ...config,
              success: function () {
                // 设置成功
                // console.log("updateAppMessageShareData share msg set succ", config);
              },
            });
            wx.updateTimelineShareData({
              ...config,
              success: function () {
                // 设置成功
                // console.log("updateTimelineShareData share msg set succ", config);
              },
            });
          });
        })
        .catch(console.log);
    },
    scrollTo(hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    updateMobileState() {
      this.$store.commit("getDeviceState");
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateMobileState);
  },
  created() {
    this.$store.commit("getDeviceState");
  },
  mounted() {
    this.wxJS();
    this.updateMobileState = this.updateMobileState.bind(this);
    window.addEventListener("resize", this.updateMobileState);
  },
  i18n: {
    messages: {
      zh: {
        common: "大搜车",
        /* eslint-disable */
        keywords:
          "大搜车,搜车,souche,dasouche,汽车新零售,买车,卖车,二手车,新车,弹个车,二手车估价,卖车估价,SaaS,4S店,主机厂,新车二网,大风车,车牛,车行168,运车管家,卖车管家,布雷克索,车易拍,秒贷,汽车直播,经销商系统,二手车管理系统,一鹿有车,二手车消费贷,新车消费贷,二手车商,软件服务,268V,二手车估价",
        description: "大搜车通过先进运营系统和完善交易服务，让车商经营更方便、交易更高效。",
        /* eslint-enable */
      },
      en: {
        common: "SOUCHE",
        /* eslint-disable */
        keywords:
          "DaSouChe,Souche,car,auto,automobile,vehicle new retailing,vehicle buying,purchase,vehicle sales,used car,pre-owned car,pre-owned vehicle,new car,Tangeche,pre-owned car valuatioin,valuation,SaaS,4S store,OEM,original equipment menufactory,car factory,secondery new car distributor,tier-2 dealership,Dafengche,Cheniu,Chehang 168,Yuncheguanjia,Maicheguanjia,BreakThought,Cheyipai,quick loan,auto live stream,DMS,dealer management system,pre-owned car management system,Yiluyouoche,pre-owned car loan,new car loan,auto loan,auto consumption loan,pre-owned car dealer,used car dealser,software service,268V",
        description: "Improving Auto Merchants' Operation Efficiency and Profitability",
        /* eslint-enable */
      },
    },
  },
  head() {
    return {
      titleTemplate: `%s - ${this.$t("common")}`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: this.$t("keywords"),
        },
        {
          hid: "description",
          name: "description",
          property: "description",
          content: this.$t("description"),
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: this.$t("description"),
        },
        {
          hid: "apple-mobile-web-app-title",
          name: "apple-mobile-web-app-title",
          content: this.$t("common"),
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue